import { Pipe, PipeTransform } from '@angular/core';
import { tryParseJSON } from '../extensions/string.extensions';

@Pipe({
    name: 'parseJSON',
    standalone: false,
})
export class ParseJSONPipe implements PipeTransform {
    public transform(value: string, property: string): string {
        const parsedJson = tryParseJSON(value, {});
        return parsedJson?.[property];
    }
}
